import firebaseSrv from '@/services/firebaseSrv.js'
// import _ from 'lodash/core'
// import router from '@/router.js'

export const namespaced = true

export const state = {
  user: {}
}

export const mutations = {
  GET_USER(state, user) {
    if (!user) {
      state.user = {
        birthCountry: '',
        birthPlace: '',
        residentCountry: '',
        residentPlace: '',
        dateOfBirth: '',
        address: '',
        zip: '',
        telephone: '',
        website: '',
        instagram: '',
        twitter: '',
        complete: false
      }
    } else {
      state.user = user
    }
  },
  UPDATE_USER(state, ob) {
    state.user[ob.key] = ob.value
  }
}
export const actions = {
  // UPDATE LOCAL VUEX STORE
  update({ commit }, payload) {
    commit('UPDATE_USER', { value: payload.value, key: payload.key })
  },
  // UPDATE USER
  updateUser({ state, dispatch, commit }) {
    commit('UPDATE_USER', {
      value: true,
      key: 'complete'
    })
    return firebaseSrv.updateUser(state.user).catch(error => {
      const notification = {
        title: 'There is a problem updating your information',
        type: 'error',
        code: error.code,
        message: error.message
      }
      // console.log(notification)
      return dispatch('notification/add', notification, { root: true })
    })
  },
  // FETCH USER
  fetchUser({ commit, dispatch }, uid) {
    firebaseSrv
      .readUser(uid)
      .then(user => {
        // pull and return the entries from the DB response
        const userOb = user.data()
        return user.exists ? userOb.user : Object
      })
      .then(user => {
        // update the local vuex store
        return commit('GET_USER', user)
      })
      .catch(error => {
        const notification = {
          title: 'There is a problem fetching your information',
          type: 'error',
          code: error.code,
          message: error.message
        }
        // console.log(notification)
        return dispatch('notification/add', notification, { root: true })
      })
  },
  // CREATE USER
  createUser({ commit, dispatch }, user) {
    return firebaseSrv
      .updateUser(user)
      .then(() => commit('GET_USER', user))
      .catch(error => {
        const notification = {
          title: 'There is a problem creating your account',
          type: 'error',
          code: error.code,
          message: error.message
        }
        // console.log(notification)
        return dispatch('notification/add', notification, { root: true })
      })
  }
}
export const getters = {}
